<template>
    <div class="columns is-mobile is-centered has-background-primary p-2" v-if="props.titoloVisibile==true">
        <h1 class="title is-4 has-text-white">LISTINI</h1>
    </div>

    <!--********** SELEZIONE LISTINO E CAMPO RICERCA **********-->
    <div class="columns is-mobile is-centered is-vcentered" v-if="props.campoRicercaVisibile==true">
        <div class="column is-3">
            <CampoTendina @valoreCambiato="listinoModifica"
                :valore=String(idListino)
                idTendina="listini"/>
        </div>
        <div class="column is-narrow">
            <span v-if="isListinoAttivo" class="tag is-success is-medium">attivo</span>
            <span v-else class="tag is-danger is-medium">disattivo</span>
        </div>
        <div class="column is-5">
            <div class="control">
                <input class="input is-primary" type="text" v-model="testoRicerca" placeholder="Cerca..." @keyup.enter="bCerca">
            </div>
        </div>
        <div class="column is-narrow" v-if="ultimoPreventivoDisponibile">
            <button class="button is-primary is-outlined" title="Torna all'ultimo computo" @click="ritornaUltimoPreventivo">
                <span class="icon"><i class="fas fa-file-invoice"></i></span>
            </button>
        </div>
    </div>

    <!--********** TABELLA LISTINI **********-->
    <div class="blocco-scroll" v-if="!elencoSospeso">
        <table class="table is-striped mx-auto">
            <thead>
                <tr>
                    <th class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" title="Aggiungi articolo"
                            @click="bSelezionaElemento('-1')" v-if="props.bottoneAggiungiVisibile==true" :disabled="!isListinoAttivo">
                            <span class="icon"><i class="fas fa-plus"></i></span>
                        </button>
                    </th>
                    <th v-if="mostraInfoSviluppo"></th> <!--Indice-->
                    <!-- <th class="has-text-centered" v-if="mostraInfoSviluppo">Id</th> -->
                    <th>Codice</th> <!--Titolo-->
                    <th>Descrizione</th>
                    <th>Prezzo</th>
                    <th>Costo</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(el, index) in elencoElementi" :key="el.id">
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bSelezionaElemento(leggiInfoDB(el).id)" :disabled="!isListinoAttivo">
                            <span class="icon" title="Modifica"><i class="fas fa-arrow-right-from-bracket"></i></span>
                        </button>
                    </td>
                    <td class="has-text-centered" v-if="mostraInfoSviluppo">{{index + 1}}</td>
                    <td>{{leggiInfoDB(el).id}}</td>
                    <td>{{el.descrizione}}</td>
                    <td class="has-text-right" v-if="'prListino' in el">{{generaStringa(el.prListino,'0,00', true)}}</td>
                    <td class="has-text-right" v-if="'prListinoVen' in el">{{generaStringa(el.prListinoVen,'0,00', true)}}</td>
                    <td class="has-text-right">{{generaStringa(calcolaCostoArticolo(el),'0,00', true)}}</td>
                    <td class="has-text-centered">
                        <button class="button is-small is-primary is-outlined" @click="bCopiaElemento(leggiInfoDB(el).id)" :disabled="props.modalitaSelezione">
                            <span class="icon" title="Copia"><i class="fas fa-copy"></i></span>
                        </button>
                    </td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td class="has-text-centered" colspan="2">{{stringaNumeroRecord}}</td>
                </tr>
            </tfoot>
        </table>
    </div>
</template>

<script setup>
    import CampoTendina from "./CampoTendina.vue";
    import { defineProps, defineEmits, computed, ref } from "vue";
    import { mostraInfoSviluppo, generaStringa, copiaTrasporto, clonaOggetto, costoVocePreventivo, statoInterfaccia } from "./../code/utilita";
    import { dbListini, leggiInfoDB, leggiInfoDBRaw, dbClienti } from "./../code/gestioneDB";

    // PROPRIETA' ED EVENTI DEL COMPONENTE

    const props = defineProps({
        testoDaCercare: {
            type: String,
            default: null },
        listinoAttivo: {
            type: Number,
            default: 14 },
        bottoneAggiungiVisibile: {
            type: Boolean,
            default: false },
        campoRicercaVisibile: {
            type: Boolean,
            default: true },
        titoloVisibile: {
            type: Boolean,
            default: true },
        modalitaSelezione: {
            type: Boolean,
            default: false }
    });
    const emit = defineEmits(['elementoSelezionato','statoInterfacciaCambiato']);

    // VARIABILI DEL COMPONENTE

    const idListino = ref(props.listinoAttivo);
    
    const isListinoAttivo = computed(() => {
        const info = dbListini.value?.[idListino.value]?.informazioni;
        return info ? info.attivo !== false : true;
    });
    const testoRicerca = ref(props.testoDaCercare);
    const elencoSospeso = ref(false);                 // Spegne tutto l'elenco durante operazione sul DB
    const stringaNumeroRecord = ref("");
    // const articoloVisibile = ref(null);

    const elencoElementi = computed(()=>{
        let tempElencoElementi = [];
        // Carico tutti gli elementi del listino
        for(const el in dbListini.value[idListino.value].articoli){
            tempElencoElementi.push(dbListini.value[idListino.value].articoli[el]);
        }
        ordinaElencoElementi(tempElencoElementi);
        filtraElencoElementi(tempElencoElementi, props.testoDaCercare, ['descrizione']);
        // filtraElencoElementi(tempElencoElementi, props.testoDaCercare, ['descrizione']);
        return tempElencoElementi;
    });

    // FUNZIONI DEL COMPONENTE

    async function listinoModifica(idList) {
        emit('statoInterfacciaCambiato', {testoRicercaListini: testoRicerca.value, listinoAttivo: parseInt(idList)});
    }

    function bCerca() {
        emit('statoInterfacciaCambiato', {testoRicercaListini: testoRicerca.value, listinoAttivo: idListino.value});
    }

    function filtraElencoElementi(elencoEl, testo, campi) {
        // Filtra gli elementi cercando il testo nei campi indicati dall'array di stringhe 'campi'
        const tempStringaNumeroRecord = elencoEl.length;
        let elencoTesti = [];
        if (testo) elencoTesti = testo.split('+');
        // Ciclo tra gli elementi di elencoTesti
        for (let j=0; j < elencoTesti.length; j++) {
            if ( (elencoTesti[j]) && (elencoTesti[j]!="") ) {
                // testo = testo.replace('+','\\+');
                let regexCerca;
                try {
                    regexCerca = new RegExp(elencoTesti[j], 'i');
                } catch (exception) {
                    console.log(exception);
                }
                for (let i=0; i < elencoEl.length; i++) {
                    let temp = null;
                    let pos = -1;
                    for (const cc in campi) {
                        if (pos == -1) {
                            if ( Array.isArray(campi[cc]) ) {
                                temp = elencoEl[i][campi[cc][0]][campi[cc][1]];
                            // } else if ( campi[cc] == 'anno' ) {
                            //     temp = dataDaTimestamp(elencoEl[i].data, 'anno');
                            } else {
                                temp = elencoEl[i][campi[cc]];
                            }
                            pos = String(temp).search(regexCerca);
                        }
                    }
                    if (pos == -1) {
                        // Ricerca nell'id
                        pos = String(leggiInfoDBRaw(elencoEl[i]).id).search(regexCerca);
                    }
                    if (pos == -1) {
                        elencoEl.splice(i,1);
                        i--;
                    }
                }
            }
        }
        if (elencoEl.length>30){
            elencoEl.splice(25,(elencoEl.length-25));
        }
        stringaNumeroRecord.value = elencoEl.length + " di " + tempStringaNumeroRecord;
    }

    async function bSelezionaElemento(idArt) {
        emit('elementoSelezionato', {
            tipo: 'articoloListino',
            idListino: idListino.value,
            idArticoloListino: idArt
        });
    }

    function ordinaElencoElementi(elenco) {
        // Ordina elenco in ordine di descrizione
        elenco.sort( (a, b) => {
            let x = a.descrizione? a.descrizione.toLowerCase(): '';
            let y = b.descrizione? b.descrizione.toLowerCase(): '';
            if (x < y) {return -1;}
            if (x > y) {return 1;}
            return 0;
        });
        return elenco;
    }

    function bCopiaElemento(idArt) {
        copiaTrasporto.value.articoloListino = {};
        copiaTrasporto.value.articoloListino = clonaOggetto(dbListini.value[idListino.value].articoli[idArt]);
        copiaTrasporto.value.articoloListinoCodiceOriginale = idArt; // Salva il codice originale per la copia
        console.log('idListino: ' + idListino.value);
        console.log('idArt: ' + idArt);
        console.log('Elemento copiato');
        console.log(JSON.stringify(copiaTrasporto.value.articoloListino));
        emit('elementoSelezionato', {
            tipo: 'articoloListino',
            idListino: idListino.value,
            idArticoloListino: '-2'
        });
    }

    function calcolaCostoArticolo(art) {
        if (!art) return 0;
        let tempVoce = {};
        if (art.prListino) {
            tempVoce = {
                prListino: art.prListino,
                rcAcq: art.rcAcq || dbListini.value[idListino.value]?.informazioni?.rcAcq
            };
        } else {
            tempVoce = {
                prListinoAcq: art.prListinoAcq,
                rcAcq: art.rcAcq || dbListini.value[idListino.value]?.informazioni?.rcAcq
            };
        }
        return costoVocePreventivo(tempVoce);
    }

    const ultimoPreventivoDisponibile = computed(() => {
        const ref = statoInterfaccia.value.ultimoPreventivo;
        if (!ref) return false;
        return !!dbClienti.value?.[ref.idCliente]?.leads?.[ref.idLead]?.preventivi?.[ref.idPreventivo];
    });

    function ritornaUltimoPreventivo() {
        const ref = statoInterfaccia.value.ultimoPreventivo;
        if (ref) {
            statoInterfaccia.value.formPreventivoTab = 2; // Forza l'apertura sul Computo
            emit('elementoSelezionato', {
                tipo: 'preventivo',
                idCliente: ref.idCliente,
                idLead: ref.idLead,
                idPreventivo: ref.idPreventivo,
                sezioneVocePreventivo: ref.sezioneVocePreventivo
            });
        }
    }

</script>

